import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import CreditableHeader from "./components/CreditableHeader";
import CreditableTable from "./components/CreditableTable";

const Creditables = () => {
  const [params] = useSearchParams();

  const verified = params.get("verified")
    ? params.get("verified") === "true"
    : "";

  const [data, setData] = useState([]);

  const [tableOptions, setTableOptions] = useState({
    year: "",
    quarter: "",
    is_verified: verified,
    search_query: "",
    current_page: 1,
    size: 10,
    sort_column: { path: "created_on", order: "desc" },
  });

  const columns = [
    { path: "name", label: "Name" },
    { path: "verified", label: "Verified" },
    { path: "created_on", label: "Date Uploaded" },
  ];

  return (
    <div className="px-6 lg:px-0">
      <div className="card p-8 mt-5">
        <CreditableHeader options={tableOptions} onChange={setTableOptions} />
        <CreditableTable
          data={data}
          columns={columns}
          options={tableOptions}
          onChange={setTableOptions}
          setData={setData}
        />
      </div>
    </div>
  );
};

export default Creditables;
